export const WORK_STATUSES = {
    INCOMPLETE: 'incomplete',
    PENDING: 'pending',
    SUBMITTED: 'submitted',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
    SUPERSEDED: 'superseded',
    UNKNOWN: 'unknown',
}
